// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1hWgu","content":"styles_content__mgZh-","checkbox":"styles_checkbox__1Flur","checkboxLabel":"styles_checkboxLabel__16IuR"};